<ng-container *ngIf="isLazyLoad && !loaded; else contentTpl">
    <button
        *ngIf="!autoload && !loading && !error"
        type="button"
        class="btn btn-link btn-sm p-0 lazy-load-btn"
        (click)="load()"
        [attr.aria-label]="'common.load' | translate"
    >
        <fa-icon [icon]="faDownload" class="mr-1"></fa-icon>
        {{ 'common.load' | translate }}
    </button>

    <span *ngIf="loading" class="text-muted">
        <fa-icon [icon]="faSpinner"></fa-icon>
    </span>

    <button
        *ngIf="error"
        type="button"
        class="btn btn-link btn-sm p-0 text-danger"
        (click)="load()"
        [attr.aria-label]="'common.try-again' | translate"
    >
        <fa-icon [icon]="faDownload" class="mr-1"></fa-icon>
        {{ 'common.try-again' | translate }}
    </button>
</ng-container>

<ng-template #contentTpl>
    <span *ngIf="showEmptyPlaceholder; else valueTpl" class="text-muted">—</span>
    <ng-template #valueTpl>
        <ng-container
            *ngTemplateOutlet="loadedTemplate; context: { $implicit: displayValue }"
        ></ng-container>
    </ng-template>
</ng-template>
